import { render, staticRenderFns } from "./WebItem.vue?vue&type=template&id=1ed1a918&scoped=true&"
import script from "./WebItem.vue?vue&type=script&lang=js&"
export * from "./WebItem.vue?vue&type=script&lang=js&"
import style0 from "./WebItem.vue?vue&type=style&index=0&id=1ed1a918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed1a918",
  null
  
)

export default component.exports